<template>
<div >
    <!-- 首页顶部
    <Header /> -->
        <router-view />
<!-- 首页底部 -->
    <Footer/>
    
</div>
</template>

<script>
//import Header from 'components/content/Header'
// import Top from 'components/content/CommenTop'
//import Footer from 'components/content/Foot'
export default {
    name:'Main',
    data(){
        return {
          
        }
    },
    components:{
        //Header,
        //Footer
    }
}
</script>

<style>


</style>